import React, { useState } from 'react';

/* MobX */
// import { observer } from 'mobx-react-lite';

/* MUI */
import { makeStyles } from '@material-ui/core/styles';
import { TextField, Grid, Button } from '@material-ui/core';
import { DataGrid } from '@material-ui/data-grid';

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    marginTop: theme.spacing(1),
  },
  buttonSubmit: {
    // marginBottom: 10,
    margin: theme.spacing(1),
    height: "75%"
  },
}));

const ManageUndeterminedAddress = props => {
  const classes = useStyles();
  const [address, setAddress] = useState("");
  const [mapBlock, setMapBlock] = useState("");
  const [assessorBlock, setAssessorBlock] = useState("");
  const [assessorLot, setAssessorLot] = useState("");
  const [showTable, setShowTable] = useState(false);
  const [page, setPage] = useState(5);

  const addressHeader = [
    { field: 'address', headerName: 'Address', width: 200 },
    { field: 'altAddress', headerName: 'Alternate Address', width: 200 },
    { field: 'mbl', headerName: 'Map Block Lot', width: 180 },
    { field: 'startDate', headerName: 'Start Date', width: 160 },
    { field: 'expiredDate', headerName: 'Expired Date', width: 160 },
    {
      field: 'setRetired', headerName: 'Set to Retired', width: 180, disableClickEventBubbling: true,
      renderCell: (params) => {
        const onClick = () => {
          console.log(params.value);
        };
        return <Button size="small" color="primary" onClick={onClick}>Retired</Button>;
      }
    },
  ];

  const addressSample = [
    {
      id: 1,
      address: "1388 Hampshire St",
      altAddress: "85 Tiffany Av",
      mbl: "0004002",
      startDate: "2021-01-09",
      expiredDate: "2023-01-09",
    },
    {
      id: 2,
      address: "855 El Camino Del Mar St",
      altAddress: "3980 24th St",
      mbl: "0026014",
      startDate: "2021-09-21",
      expiredDate: "2023-09-21",
    },
  ]

  const addressSearch = () => {
    setShowTable(true);
  }

  return (
    <div className={classes.paper}>
      {/* <form autoComplete="off" noValidate className={classes.form} onSubmit={assessorHandleSubmit}> */}
      <Grid container spacing={1}>
        <Grid item xs={10}>
          <TextField name="searchAddress" label="Search Address" variant="outlined" required fullWidth value={address} onChange={(e) => setAddress(e.target.value)} />
        </Grid>
        <Grid item xs={2}>
          <Button
            className={classes.buttonSubmit}
            variant="contained"
            color="primary"
            size="large"
            type="submit"
            fullWidth
            disabled={address ? false : true}
            onClick={addressSearch}
          >
            Search
          </Button>
        </Grid>
        <Grid item xs={5}>
          <TextField name="assessor_block" variant="outlined" label="Assessor Block" fullWidth value={assessorBlock} onChange={(e) => setAssessorBlock(e.target.value)} />
        </Grid>
        <Grid item xs={5}>
          <TextField name="assessor_lot" variant="outlined" label="Assessor Lot" fullWidth value={assessorLot} onChange={(e) => setAssessorLot(e.target.value)} />
        </Grid>
        <Grid item xs={2}>
          <Button
            className={classes.buttonSubmit}
            variant="contained"
            color="primary"
            size="large"
            type="submit"
            fullWidth
            disabled={assessorBlock ? false : true}
            onClick={addressSearch}
          >
            Search
          </Button>
        </Grid>
        <Grid item xs={10}>
          <TextField name="mapblklot_no" variant="outlined" label="Map Block" fullWidth value={mapBlock} onChange={(e) => setMapBlock(e.target.value)} />
        </Grid>
        <Grid item xs={2}>
          <Button
            className={classes.buttonSubmit}
            variant="contained"
            color="primary"
            size="large"
            type="submit"
            fullWidth
            disabled={mapBlock ? false : true}
            onClick={addressSearch}
          >
            Search
          </Button>
        </Grid>
        {showTable &&
          <Grid item xs={12}>
            <DataGrid
              columns={addressHeader}
              rows={addressSample}
              pageSize={page}
              onPageSizeChange={(pageSize, details) => { setPage(pageSize); }}
              autoHeight
              rowsPerPageOptions={[5, 10, 25]}
            />
          </Grid>
        }
      </Grid>
      {/* </form > */}
    </div >
  )
};

export default ManageUndeterminedAddress;